<template>
  <footer id="footer" role="contentinfo">
    <div class="container mb-4">
      <hr>
      <div class="d-lg-flex align-items-center">
        <!-- <img class="m-3" src="static/logo-multichoice-enriching-lives.svg" width="80" height="50" alt="MultiChoice Enriching Lives"> -->
        <img class="m-3" src="http://thinktankapi.multichoice.com/wp-content/uploads/2024/03/Logo-strip-No-BG_2024.png" height="50">
        <!--img class="m-3" src="static/DStv.png" width="90" height="35" alt="DSTV">
        <img class="m-3" src="static/GOtv.png" width="90" height="35" alt="GOTV">
        <img class="m-3" src="static/ShowMax.png" width="150" height="30" alt="SHOWMAX">
        <img class="m-3" src="static/M-Net.png" width="60" height="40" alt="M-NET">
        <img class="m-3" src="static/SS Logo.png" width="50" height="40" alt="SUPERSPORTS">
        <img class="m-3" src="static/irdeto_logo.png" width="90" height="40" alt="Irdeto"-->
        <!-- <img class="m-3 mr-lg-auto" src="static/logo-multichoice-africa.svg" width="80" height="50" alt="MultiChoice Africa logo"> -->
        <h6 class="text-center text-lg-right text-secondary">
          <small>ThinkTank 2014 - {{ new Date().getFullYear() }}<br>
            All rights reserved<br>
            <router-link to="/page/privacy-policy">Privacy policy</router-link> | <a href="mailto:thinktank@multichoice.co.za" target="_top">Contact Us</a>
          </small>
        </h6>
      </div>
      <div id="google_translate_element"></div>
      <button v-if="showBackToTop" type="button" class="btn btn-primary backToTop" v-on:click="backToTop()"><i class="fas fa-chevron-up"></i></button>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      scrollPosition: window.scrollY,
      showBackToTop: false
    }
  },
  created () {
    window.addEventListener('scroll', this.checkPosition)
  },
  destroyed () {
    window.removeEventListener('scroll', this.checkPosition)
  },
  methods: {
    checkPosition: function () {
      this.showBackToTop = window.scrollY > 500
    },
    backToTop: function () {
      var currentY = window.pageYOffset
      var animateScroll = setInterval(function () {
        window.scrollTo(0, currentY)
        if (currentY > 1500) {
          currentY -= 35
        } else if (currentY > 1250) {
          currentY -= 30
        } else if (currentY > 1000) {
          currentY -= 25
        } else if (currentY > 750) {
          currentY -= 20
        } else if (currentY > 500) {
          currentY -= 15
        } else if (currentY > 250) {
          currentY -= 10
        } else {
          currentY -= 5
        }
        if (currentY <= 0) {
          clearInterval(animateScroll)
        }
      }, 1)
    }
  }
}
</script>

<style lang="less">
  .backToTop {
    border-radius: 19px;
    position: fixed;
    bottom: 10px;
    right: 10px;
    opacity: 0.3;
    z-index: 10000;
    transition: opacity 0.35s;
    &:hover {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SiteFooter.vue